import React, { useEffect } from "react";
import {
  ArrowIcon,
  BackArrowIcon,
  CalendarIcon,
  NoCaptureFallbackIcon
} from "../../Assets/assets";
import defaultFace from "../../Assets/face/defaultFace.svg";
import Button from "../../Components/Button/Button";
import { setSelectedLocation } from "../../Redux/locations/action";
import { dateAndTimeConverter } from "../../Utils/constants";

export default function LatestCaptureData(props) {
  const defaultStatus = {
    success: {
      title: "Matched",
      style: {
        color: "#0044CC",
        backgroundColor: "#0044CC14"
      }
    },
    denied: {
      title: "Denied",
      style: {
        color: "#FF4C4C",
        backgroundColor: "#FF4C4C1A"
      }
    },
    failed: {
      title: "No Match Found",
      style: {
        color: "#FF4C4C",
        backgroundColor: "#FF4C4C1A"
      }
    },
    offline: {
      title: "Offline",
      style: {
        color: "#B58400",
        backgroundColor: "#F6C95829"
      }
    },
    pending: {
      title: "Pending Approval",
      style: {
        color: "#B58400",
        backgroundColor: "#F6C95829"
      }
    }
  };

  const StatusCard = (props) => {
    const getStatus = () => {
      return props.data.body
        ? "offline"
        : props.data.approval?.status === "PENDING" && props.data.employee?.id
        ? "pending"
        : props.data.approval?.status === "DENIED"
        ? "denied"
        : props.data.success === true
        ? "success"
        : props.data.success === false
        ? "failed"
        : "offline";
    };

    useEffect(() => {
      if (props.selectedLocation) {
        setSelectedLocation(null);
      }
    }, [props.selectedLocation]);

    return (
      <div
        className="display-flex inherit-parent-width flex-justify-content-space-between flex-align-items-center padding-top-default padding-bottom-default cursor-pointer"
        onClick={() => {
          props.setFaceComparisonData(props.data);
          props.setCapturedId(props.data?.documentId);
          props.getReferenceImage(props.data);
          props.navigate(`/faceIdentification/${getStatus()}?type=list`);
        }}
      >
        <div className="display-flex flex-align-items-center">
          <div
            style={{
              width: "66px",
              height: "66px"
            }}
          >
            {props.data?.fileUrl || props.data.body?.previewPhoto ? (
              <img
                className="inherit-parent-width inherit-parent-height"
                src={props.data.body?.previewPhoto || props.data?.fileUrl}
                alt="capturedImage"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultFace;
                }}
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
          <div className="padding-left-large">
            <div
              className="font-size-medium"
              style={{
                opacity: props.data.employee?.name ? "1" : "0.5",
                fontWeight: "500"
              }}
            >
              {props.data.employee?.name || "UNKNOWN MEMBER"}
            </div>
            <div className="white-space-nowrap font-size-small padding-top-default padding-bottom-default">
              {props.data.body?.PCTNo || props.data.location.PCTNo} -{" "}
              {props.data.body?.address || props.data.location.address} &#x2022;
              {dateAndTimeConverter(
                parseInt(props.data.body?.createdAt) || props.data.createdAt,
                "Time"
              )}
            </div>
            <div
              className="padding-small padding-left-default padding-right-default border-radius-default width-fit-content font-size-small"
              style={{
                ...defaultStatus[getStatus()]?.style,
                borderRadius: "8px",
                fontWeight: "500"
              }}
            >
              {defaultStatus[getStatus()]?.title}
            </div>
          </div>
        </div>
        <div>
          <ArrowIcon />
        </div>
      </div>
    );
  };

  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div className="inherit-parent-height inherit-parent-width overflow-hidden">
        <div className="display-flex flex-justify-content-space-between padding-bottom-large">
          <div className="display-flex flex-align-items-center">
            <div
              style={{
                border: "solid 1px var(--tertiaryColor6)"
              }}
              className="font-size-medium padding-default font-color-tertiaryColor6"
            >
              Newest
            </div>
            <div
              style={{ transform: "rotate(-90deg)" }}
              className="padding-top-large"
            >
              <BackArrowIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
          <div className="display-flex flex-align-items-center">
            <div className="font-size-medium font-color-tertiaryColor6">
              {dateAndTimeConverter(+new Date(), "secondDate")}
            </div>
            <div className="padding-left-large">
              <CalendarIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
        </div>
        <div
          style={{
            height: "calc(100% - 72px)"
          }}
          className="overflow-auto hide-scrollbar"
        >
          {props.data.length === 0 ? (
            <div
              className="inherit-parent-height inherit-parent-width padding-top-large padding-bottom-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
              data-cy="no-locations-fallback"
            >
              <div>
                <NoCaptureFallbackIcon />
              </div>
              <div className="padding-top-larger">
                No Capture Data Available!
              </div>
            </div>
          ) : (
            props.data.map((data, i) => (
              <React.Fragment key={i}>
                <StatusCard
                  data={data}
                  setCapturedId={props.setCapturedId}
                  setFaceComparisonData={props.setFaceComparisonData}
                  getReferenceImage={props.getReferenceImage}
                  navigate={props.navigate}
                />
              </React.Fragment>
            ))
          )}
        </div>
      </div>

      <div>
        <Button
          data-cy="NEW-CAPTURE-BUTTON"
          text="New capture"
          boxShadow={false}
          onClick={() => {
            props.navigate("/faceIdentification/getNearestLocation");
          }}
        />
      </div>
    </div>
  );
}
